import React from "react";
import { useLang } from "@/context/LangContext";
import { whatsappLink, WHATSAPP_NUMBER } from "@/lib/config";

const WhatsAppButton = () => {
  const { t } = useLang();
  if (!WHATSAPP_NUMBER) return null;
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label={t("whatsapp.tooltip")}
      title={t("whatsapp.tooltip")}
      className="fixed bottom-6 right-6 z-40 group flex items-center"
    >
      <span className="absolute right-16 whitespace-nowrap bg-charcoal text-white text-xs px-3 py-2 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden sm:block">
        {t("whatsapp.tooltip")}
      </span>
      <span className="w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-105 transition-transform">
        <svg viewBox="0 0 32 32" width="28" height="28" fill="white" aria-hidden="true">
          <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.256.59 4.46 1.712 6.4L3.2 28.8l6.56-1.712a12.74 12.74 0 006.244 1.592h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.68-12.805-12.68zm0 23.2h-.004a10.6 10.6 0 01-5.4-1.48l-.388-.23-4.02 1.05 1.073-3.92-.253-.402a10.56 10.56 0 01-1.62-5.62c0-5.86 4.77-10.63 10.63-10.63 2.84 0 5.51 1.107 7.52 3.117a10.56 10.56 0 013.11 7.52c0 5.86-4.77 10.63-10.63 10.63zm5.83-7.96c-.32-.16-1.89-.933-2.18-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.59-1.893-1.777-2.213-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.733-.986-2.373-.26-.623-.523-.538-.72-.548l-.613-.011c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.823.763.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.89-.773 2.156-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
